<template>
  <AppView class="contest-end">
    <p>{{ $t('contestEnd.info') }}</p>
    <p>{{ $t('contestEnd.download') }}</p>
    <p><a :href="$t('contestEnd.link.url')" target="_new">{{ $t('contestEnd.link.name') }}</a></p>
  </AppView>
</template>

<script>
import AppView from '@/components/AppView.vue';

export default {
  name: 'ContestEnd',
  components: {
    AppView,
  },
};
</script>

<style lang="scss">
.contest-end {
  p {
    text-align: center;
    font-size: 30px;
    line-height: 1.25em;

    a {
      color: inherit;
    }

    &:not(:first-child) {
      margin-top: 20px;
    }
  }
}
</style>
